<template>
  <div>
    <ListContent
      v-if="wrldIndex != null"
      :wrld="wrldIndex"
    >
      <!-- <template v-slot:filters>
        <ShipmentsQuoteFilters/>
      </template> -->
      <template v-slot:listActionPanel>
        <WrldListActionPanel
          :isCheckable="false"
        >
          <template v-slot:extraButtons>
            <div>
              <!-- <QuoteAddOfferForm /> -->
              <QuotingRequestForm :transportTypes="transportTypes" :incoterms="incoterms" v-show="!getIfOneOfQuotesIsAccepted"/>
            </div>
          </template>
        </WrldListActionPanel>
      </template>
      <!-- <div style="display: block; height: 24px;"></div> -->
      <template v-slot:list>
        <span v-if="computedItems.length > 0 && !getQuoteListFetching">
          <ListItemCardBig
            v-for="item in computedItems"
            :key="item.quoteID"
            :resource="{...item, id: item.quoteID}"
            :isCheckable="false"
            :isSelectable="false"
            color="#4c9aff"
            @card-clicked="handleQuoteClick"
          >
            <QuoteItemCardBig
              :quote="{...item, id: item.quoteID}"
              :isExpand="item.quoteID === expandedID"
              @expand="handleExpand"
              @accept="handleAcceptedQuote"
              @reject="handleRejectedQuote"
              @cancel="handleCanceledRequest"
            />
          </ListItemCardBig>
        </span>
        <div v-else-if="getQuoteListFetching">
          <div class="drop--sortable--tree__container">
            <div v-for="(key, index) in new Array(10)" :key="index" class="drop--sortable--tree__card drop--sortable--tree--card__topLevel placeholderLoader background--transparent">
            </div>
          </div>
        </div>
        <div v-else>
          <span class="headline">{{$t('quotes.empty_quotes')}}</span>
        </div>
      </template>
    </ListContent>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuoteItemCardBig from '@/components/shipments/new/quoting/QuoteItemCardBig'
import WrldListActionPanel from '@/components/wrld/generic/WrldListActionPanel'
import ListItemCardBig from '@/components/wrld/generic/ListItemCardBig'
import ListContent from '@/components/wrld/generic/ListContent'
import ShipmentsQuoteFilters from '@/components/shipments/new/quoting/ShipmentsQuoteFilters'
import QuotingRequestForm from '@/components/shipments/new/quoting/QuotingRequestForm'
import { quoteService } from "@/_services"
// import QuoteAddOfferForm from '@/components/shipments/new/quoting/QuoteAddOfferForm'

export default {
  name: 'ShipmentsQuotingContent',
  components: {
    QuoteItemCardBig,
    ListItemCardBig,
    ListContent,
    WrldListActionPanel,
    ShipmentsQuoteFilters,
    QuotingRequestForm
    // QuoteAddOfferForm
  },
  data () {
    return {
      expandedID: null,
      wrldIndex: null,
      transportTypes: [],
      incoterms: []
    }
  },
  created () {},
  mounted () {
    this.setIsShipmentDetails({ flag: true })
    if (this.getShipmentResourceDetails === null) {
      this.setShipmentDetails({ shipmentID: this.$route.params.shipmentID })
    } else if (this.getShipmentResourceDetails.id !== this.$route.params.shipmentID) {
      this.setShipmentDetails({ shipmentID: this.$route.params.shipmentID })
    }
    if (this.getQuoteList.length < 1) {
      this.fetchQuoteList({ shipmentID: this.$route.params.shipmentID })
    }
    this.wrldIndex = {index: 'Quotes', id: this.$route.params.shipmentID, isSecond: true}

    this.transportTypes = []
    this.incoterms = []
    quoteService.getTransportTypeEnums().then((response) => {
      response.forEach(({ name }) => {
        this.transportTypes.push({
          text: name
        })
      })
    })

    quoteService.getIncotermsEnums().then((response) => {
      response.forEach(({ name }) => {
        this.incoterms.push(name)
      })
    }).catch((error) => {
      console.error(error)
    })
  },
  methods: {
    ...mapActions({
      setShipmentOverviewDrops: 'setShipmentOverviewDrops',
      updateSecondResourceOverviewList: 'updateSecondResourceOverviewList',
      setIsShipmentDetails: 'setIsShipmentDetails',
      setShipmentDetails: 'setShipmentDetails',
      fetchQuoteList: 'fetchQuoteList',
      handleRejectQuote: 'handleRejectQuote',
      handleAcceptQuote: 'handleAcceptQuote',
      handleCancelRequest: 'handleCancelRequest',
      clearQuoteList: 'clearQuoteList'
    }),
    handleQuoteClick () {},
    // handleQuoteCardColor (quote) {
    //   switch (quote.quoter.type) {
    //     case '1PL':
    //       return '#4c9aff'
    //     case '2PL':
    //       return '#ffdc7f'
    //     case 'Express':
    //       return '#ffb900'
    //     default:
    //       return '#4c9aff'
    //   }
    // },
    handleExpand (quoteID) {
      if (quoteID === this.expandedID) {
        this.expandedID = null
      } else {
        this.expandedID = quoteID
      }
    },
    handleAcceptedQuote (quoteID) {
      this.handleAcceptQuote({quoteID, shipmentID: this.$route.params.shipmentID})
    },
    handleRejectedQuote (quoteID) {
      this.handleRejectQuote({quoteID, shipmentID: this.$route.params.shipmentID})
    },
    handleCanceledRequest (quoteID) {
      this.handleCancelRequest({quoteID, shipmentID: this.$route.params.shipmentID})
    },
    handleRejectQuotesOnAccept (acceptedQuoteID) {
      this.rejectQuotesOnAccept({ acceptedQuoteID, shipmentID: this.$route.params.shipmentID, quotesList: this.getQuoteList })
    }
  },
  computed: {
    ...mapGetters([
      'getShipmentIsFetching',
      'getSelectedResourceID',
      'getSecondResourceOverviewList',
      'getShipmentResourceDetails',
      'getQuoteList',
      'getQuoteListFetching',
      'getIfOneOfQuotesIsAccepted'
    ]),
    computedItems () {
      return this.getQuoteList
    }
  },
  beforeDestroy() {
    this.clearQuoteList()
  },
}
</script>

<style lang="scss" scoped>
</style>
